export default {
    type: 'text',
    format: {},
    default: {
        logic: 'contains'
    },
    setting: {
        logic: ['contains']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Condition',
        category: ['User', 'Collection'],
        description: 'Condition note set on the collection item.',
        summarise: {
            prefix: 'Condition contains'
        }
    },
    rules: {
        linked: [],
        legacy: ['collection.condition']
    }
}
